/* ==================================================
#Image functions
#Recently viewed
#Load more / infinite load
#Filter products with AJAX
#Search autocomplete
#Sidebar filter on collection pages
#Misc
#Quick shop
#Newsletter popup
#Currency converter
#Product Media Controls
#Plyr setup

/*============================================================================
  Image functions
==============================================================================*/

window.usePageDots = Shopify.theme_settings.page_dots_enabled;

 window.imageFunctions = {
  zoom: function(){
    var $image = $(event.target);
    var zoomSrc = $image.data('zoom-src');

    if (zoomSrc) {
      $image.wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
        url: zoomSrc,
        touch: false,
        magnify: 1
      });
    }
  },
  linkGalleryAndCarousel: function($gallery, $carousel){

    $carousel.find('.gallery-cell:nth-child(1)').addClass('is-nav-selected');

    //EVENT - click on carousel item to slide gallery
    $carousel.on( 'click', '.gallery-cell', function() {
        var index = $(this).index();
        $carousel.find('.is-nav-selected').removeClass('is-nav-selected');
        $(this).addClass('is-nav-selected');
        $gallery.flickity( 'select', index );
    });

    //EVENT - update carousel based on gallery index
    $gallery.on( 'select.flickity', function() {
      var galleryData = $(this).data('flickity');
      if (galleryData){
        $carousel.find('.is-nav-selected').removeClass('is-nav-selected');
        $carousel.find('.gallery-cell:nth-child(' + (galleryData.selectedIndex + 1) + ')').addClass('is-nav-selected');
      }
    });
  },
  fullWidth: function(images, imageContainer){
    $(images).each(function(){
      var $image = $(this),
          alt = $image.attr('alt'),
          src = $image.attr('src');

      if (alt.indexOf("[") >= 0){

        //remove from description
        $image.remove();

        //find shortcode values and remove from alt
        var shortcodes = alt.match(/\[(.*?)\]/ig);
        alt = alt.replace(/\[(.*?)\]/ig, '');

        //remove brackets from shortcode to be used as classes
        var captionClass = $.map( shortcodes, function( value, index ) {
            value = value.replace(/[\[\]']+/g,'');
            return value;
        });

        //markup for caption

        var caption = [
            '<div class="position-' + (captionClass.length ? captionClass : 'center') + ' caption js-caption">',
              '<div class="caption-content caption-background-false align-' + (captionClass.length ? captionClass : 'center') + '">',
                '<p class="headline">' + alt + '</p>',
              '</div>',
            '</div>'
        ].join('');

        //image attributes added
        $image.attr({
          alt: alt,
          class: 'lazyload fade-in',
          src: src,
          dataSizes: 'auto'
        });

        var image = $image.prop('outerHTML')
        var banner =  '<div class="banner">' + image + caption + '</div>'

        $(imageContainer).append(banner);
      }
    })
  },
  showSecondaryImage: function(){
    if (Shopify.media_queries.large.matches) {
      $('.has-secondary-media-swap').off().on('mouseenter', function() {
        if (Shopify.theme_settings.product_form_style == 'dropdown') {
          $(this).find('.product_gallery').toggleClass('secondary-media-hidden');
        }
        $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
        $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
        $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
        window.videoFeature.enableVideoOnHover($(this));
      });

      $('.has-secondary-media-swap').on('mouseleave', function() {
        if (Shopify.theme_settings.product_form_style == 'dropdown') {
          $(this).find('.product_gallery').toggleClass('secondary-media-hidden');
        }
        $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
        $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
        $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
        window.videoFeature.enableVideoOnHover($(this));
      });
    }
  },
  //Fix for flickity issue on IOS, where you can't swipe through the slider
  flickityIosFix: function()  {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  }
}

/* ============================================================================
  Recently viewed
============================================================================== */

window.recentlyViewed = {
  init() {
    let productHandle;
    let rvCookie;
    let rvProducts;
    let displayProducts;
    let rvProductArray;

    if ($('.js-product_section[data-rv-handle]').length) {
      productHandle = $('.js-product_section').data('rv-handle').toString();
      rvCookie = window.Cookies.get('recentlyViewed');
      rvProducts = window.recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.recently-viewed__section').length) {
      rvCookie = window.Cookies.get('recentlyViewed');
      rvProducts = window.recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.js-sidebar-recently-viewed').length) {
      rvCookie = window.Cookies.get('recentlyViewed');
      rvProducts = window.recentlyViewed.getCookieProducts(rvCookie, productHandle);
    }

    if (rvProducts) {
      rvProductArray = unescape(rvProducts).split(',');
    }

    if (productHandle) {
      if (!$.inArray(productHandle, rvProductArray) !== -1) {
        displayProducts = [];
        rvProductArray.unshift(productHandle);
        $.each(rvProductArray, (_i, el) => {
          if ($.inArray(el, displayProducts) === -1) displayProducts.push(el);
        });
      }

      window.recentlyViewed.setCookieProducts(displayProducts);
    } else {
      displayProducts = rvProductArray;
    }

    if ($('.recently-viewed__section').length) {
      const parent = '.recently-viewed__section';
      const recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');

      if (recentlyViewedProductsLoaded) {
        return false;
      }

      window.recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    } else if ($('.js-recently-viewed .rv-main').length) {
      const parent = '.js-recently-viewed';
      const recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');

      if (recentlyViewedProductsLoaded) {
        return false;
      }

      window.recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    }

    if ($('.sidebar .js-sidebar-recently-viewed').length) {
      const parent = '.sidebar .js-sidebar-recently-viewed';
      const recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');
      if (recentlyViewedProductsLoaded) {
        return false;
      }

      if (productHandle) {
        window.recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
      } else {
        window.recentlyViewed.getProductInformation(parent, displayProducts);
      }
    }
  },
  getCookieProducts(rvCookie, productHandle) {
    if (!rvCookie && productHandle) {
      window.Cookies.set('recentlyViewed', productHandle, { expires: 30, path: '/' });
      rvCookie = window.Cookies.get('recentlyViewed');
    } else {
      rvCookie = window.Cookies.get('recentlyViewed');
    }

    return rvCookie;
  },
  setCookieProducts(rvProductArray) {
    window.Cookies.set('recentlyViewed', escape(rvProductArray.join(',')), { expires: 30, path: '/' });
  },
  getProductInformation(parent, displayProducts, productHandle) {
    // Add data-attribute 'recently-viewed-items-loaded="true" to parent container
    $(parent).attr('data-recently-viewed-items-loaded', 'true');

    if (productHandle) {
      displayProducts.splice($.inArray(productHandle, displayProducts), 1);
    }

    const productLimit = $(parent).data('visible-products');

    if (productLimit && displayProducts) {
      displayProducts = displayProducts.slice(0, productLimit);
    }

    $.each(displayProducts, (index, value) => {
      if (value) {
        $(parent).removeClass('hidden');

        $(parent).parents('.sidebar-block').show();

        $.ajax({
          type: 'GET',
          url: `/products/${value}?view=rv`,
          success(data) {
            const rvProduct = $(data).find('.js-recently-viewed-product');

            $(parent).find(` .rv-box-${index}`).append(rvProduct);

            if (window.Currency.show_multiple_currencies) {
              window.currencyConverter.convertCurrencies();
            }

            // Initialize show secondary media on hover feature
            if (Shopify.theme_settings.collection_secondary_image) {
              window.imageFunctions.showSecondaryImage();
            }

            const $video = rvProduct.find('[data-html5-video] video, [data-youtube-video]');
            if ($video.length > 0) {
              window.videoFeature.setupPlayerForRecentlyViewedProducts(rvProduct.find('[data-html5-video] video, [data-youtube-video]'));
            }
          },
          error(x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
          },
          dataType: 'html',
        });
      }

      if ($(parent).find('.rv-main').hasClass('js-rv-slider')) {
        if (displayProducts.length <= productLimit) {
          $('.js-rv-slider .gallery-cell').eq(displayProducts.length).nextAll().addBack()
            .remove();
        } else {
          $('.js-rv-slider .gallery-cell').eq(productLimit).nextAll().addBack()
            .remove();
        }
        window.recentlyViewed.createSlider(parent, productLimit);
      } else if ($(parent).find('.rv-main').hasClass('js-rv-grid')) {
        if (displayProducts.length <= productLimit) {
          $('.js-rv-grid .thumbnail').eq(displayProducts.length).nextAll().addBack()
            .remove();
        } else {
          $('.js-rv-grid .thumbnail').eq(productLimit).nextAll().addBack()
            .remove();
        }
      }
    });
  },

  createSlider() {
    const productsGenerated = $('.js-rv-slider').find('.gallery-cell').length;
    const productsAvailable = $('.js-rv-slider').data('products-available');
    let cellAlign = 'left';
    let wrapAround = true;
    let prevNextButtons = true;
    let initialIndex;

    if (window.productsPerSlide >= productsGenerated) {
      cellAlign = 'center';
      wrapAround = false;
      prevNextButtons = false;
    }

    if (window.productsPerSlide === '2' && productsAvailable > window.productsPerSlide || window.productsPerSlide === '4' && productsAvailable > window.productsPerSlide || window.productsPerSlide === '6' && productsAvailable > window.productsPerSlide) {
      initialIndex = 0;
    } else if (window.productsPerSlide === '3' && productsAvailable) {
      initialIndex = 1;
    } else if (window.productsPerSlide === '5' && productsAvailable) {
      initialIndex = 2;
    } else if (window.productsPerSlide === '7' && productsAvailable) {
      initialIndex = 3;
    }

    $('.js-rv-slider').flickity({
      lazyLoad: 2,
      imagesLoaded: true,
      prevNextButtons,
      wrapAround,
      cellAlign,
      pageDots: window.usePageDots,
      contain: true,
      freeScroll: true,
      arrowShape: window.arrowSize,
      initialIndex,
    });

    $('.js-rv-slider').addClass('slider-initialized');
  },
};

/* ===============================================
  #Load more / infinite load
================================================== */

//Collection template

var enableLoadMoreButton = function(parentClass) {

  var $grid = parentClass + '[data-load-more--grid]';
  var $gridItems = parentClass + ' [data-load-more--grid-item]';


  $('body').on('click', '[data-load-more]', function (e) {

    e.preventDefault();

    var $button = $(this);
    var url = $button.attr('href');

    loadNextPage(url, $button);
  });

  function loadNextPage(url, $button) {

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      beforeSend: function () {
        $button.addClass('is-loading');
        $('.load-more__icon').addClass('loading-in-progress').css({
          'height': '40px',
          'width': '40px',
          'opacity': '1'
        });
      },
      success: function success(data) {
        $button.removeClass('is-loading');
        $('.load-more__icon').removeClass('loading-in-progress').css({
          'height': '0',
          'width': '0',
          'opacity': '0'
        });

        var thumbnails = $(data).find($gridItems);
        var loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');

        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $($grid).first().append(thumbnails).append($('.js-load-more'));

        // When there are no additional pages, hide load more button
        if (typeof loadMoreButtonUrl == 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error: function (x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);
      }
    });
  }
}

window.enableLoadMoreProducts = function(){
  $('body').on('click', '.js-load-more a', function(e){
    enableInfiniteScroll();
    e.stopPropagation();
    return false;
  });
}

var enableInfiniteScroll = function(){
  if ($('.collection-matrix').length) {
    var infiniteScroll = new Waypoint.Infinite({
      element: $('.collection-matrix')[0],
      items: '.collection-matrix',
      more: '[data-load-more]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad: function(){
        $('.js-load-more').hide();
      },
      onAfterPageLoad: function(data){
        $('.collection-matrix > .collection-matrix .thumbnail').unwrap('.collection-matrix');
        if (Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges){
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
        if (window.Currency.show_multiple_currencies) {
          window.currencyConverter.convertCurrencies();
        }
        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        window.productPage.init();
        window.productPage.runOptionSelector();

        window.hideNoScript();

        window.videoFeature.init();

        // Initialize show secondary media on hover feature
        if (Shopify.theme_settings.collection_secondary_image){
          window.imageFunctions.showSecondaryImage();
        }

        // # Show the message with savings amount
        messageWithSavingsAmount();

        // # Accessibility
        productCardsAccessibility();

        // # Product swatch will update based on the availability at least one size option
        productCardsSwatch();

        // # Variants selection functionality (mobile)
        variantsSelection();

        // Refresh waypoints
        Waypoint.refreshAll()
        
        // add the ability to change color swatch images without quick shop
        window.quickShop.init();

        // if (Shopify.theme_settings.quick_shop_enabled){
        //   window.quickShop.init();
        // }
      }
    })
  }
}

// # Show the message with savings amount
function messageWithSavingsAmount() {
  $('.product-card').each(function() {
    let productCard = $(this);

    if (productCard.find('.price-ui .price').hasClass('price--sale'))
      productCard.find('.my-savings').css('display', 'block');
  });
}

// # Accessibility
function productCardsAccessibility() {
  isEl('.product-card', function() {
    $('.product-card.quick-shop-enabled').each(function() {
      $('.product-card.quick-shop-disabled .swatch-options:not(.color-variant-options), .product-card #size-guide-placeholder, .product-card #add-to-wishlist, .product-card #pre-order').remove();
    });
  })
};

// # Product swatches will be updated based on the availability of at least one size option
function productCardsSwatch() {
  isEl('.product-card', function() {
    $('.product-card').each(function() {
      let currentProductCard = $(this);
      let sizeVariants = currentProductCard.find('.swatch[data-option-index="1"]:not(.color-swatch) .swatch-element');

      if (sizeVariants.hasClass('available')) currentProductCard.find('.swatch[data-option-index="0"] .swatch-element').removeClass('soldout');

      setTimeout(function() {
        if (sizeVariants.hasClass('soldout') && sizeVariants.hasClass('available'))
          currentProductCard.find('.swatch[data-option-index="1"]:not(.color-swatch) .swatch-element.soldout:not(:last-of-type)').prev('input').removeAttr('checked').siblings('.swatch-element.available:first').prev('input').attr('checked', true);
      }, 250)
    })
  })
};

// # Variants selection functionality (mobile)
function variantsSelection() {
  if (isTouch) {
    $('.product-card:not(".quick-shop-disabled")').each(function() {
      let productCard = $(this);

      function changeButtons() {
        productCard.find('.ajax-submit').hide()
        productCard.find('.choose-variant').css('display', 'flex'); 
      }

      if (productCard.find('.swatch-options:not(.color-variant-options) .swatch:nth-child(1) .swatch-element').length > 1 ||
          productCard.find('.swatch-options:not(.color-variant-options) .swatch:nth-child(2) .swatch-element').length > 1) {
        changeButtons();

        productCard.find('.ajax-submit').addClass('choose-variant-button');
      
        $(document).click(function(event) {
          if (!$(event.target).closest(productCard).length) {
            changeButtons();
          }
        });

        productCard.on('click', '.choose-variant', function() {
          $(this).next('.ajax-submit').css('display', 'flex').find('.choose-variant-text').show().prev().hide();
          $(this).hide();
        })

        productCard.on('click', '.ajax-submit', function() {
          $(this).find('.choose-variant-text').hide().prev().show();
        })
      }
    });
  }
}

//Search template
var enableLoadMoreSearch = function(){
  $('body').on('click', '.js-load-more a', function(e){
    enableInfiniteSearchScroll();
    e.stopPropagation();
    return false;
  });
}

var enableInfiniteSearchScroll = function(){
  if ($('.search-matrix').length) {
    var infiniteSearchScroll = new Waypoint.Infinite({
      element: $('.search-matrix')[0],
      items: '.search-matrix',
      more: '[data-load-more]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad: function(){
        $('.js-load-more').hide();
      },
      onAfterPageLoad: function(data){
        $('.search-matrix > .search-matrix .thumbnail').unwrap('.search-matrix');
        if (Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges){
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
        if (window.Currency.show_multiple_currencies) {
          window.currencyConverter.convertCurrencies();
        }
        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        window.productPage.init();
        window.productPage.runOptionSelector();
        if (Shopify.theme_settings.quick_shop_enabled) {
          window.quickShop.init();
        }
        window.hideNoScript();

        window.videoFeature.init();

        // Initialize show secondary media on hover feature
        if (Shopify.theme_settings.collection_secondary_image){
          window.imageFunctions.showSecondaryImage();
        }
      }
    })
  }
}

window.hideNoScript = function(){
  // Used to ensure noscript elements are hidden when JS is present.
  $('.image__container .noscript').addClass('hidden');
}

/*============================================================================
  Filter Products with AJAX
==============================================================================*/

Shopify.queryParams = {};
if (location.search.length) {
 for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
     Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

var quickFilter = {
  init: function(){
    var selectedOptions = [],
        query = '',
        currentTags = '',
        url1 = $.url('1') ? '/' + $.url('1') + '/' : ''

        // Check the length of url1 to see if there is a translation added to the end of the host URL, if there is, use a different path
        if ( url1.length <= 4) {
          url2 = $.url('2') ? $.url('2') + '/' : '',
          url3 = $.url('3') ? $.url('3') + '/' : '',
          path = url1 + url2 + url3;
        } else {
          url2 = $.url('2') ? $.url('2') + '/' : '',
          path = url1 + url2;
        }

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){
      var $tagFilterValue = $('#tag_filter').val();

      if ($('#tag_filter').data('default-collection') != $tagFilterValue){
        urlTag = $tagFilterValue.substr($tagFilterValue.lastIndexOf('/') + 1);
        var tagFilterUrl = $tagFilterValue.substr($tagFilterValue)

        // apply the selected attribute to the proper option value in tag filter dropdown
        $('#tag_filter option').removeAttr('selected');
        $('#tag_filter option[value="' + tagFilterUrl + '"]').attr('selected', 'selected')

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function (){
      selectedOptions.push($(this).val());
    });
    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    Shopify.queryParams.sort_by = query;
    query = '?' + $.param(Shopify.queryParams);

    quickFilter.processUrl(path, currentTags, query);
  },
  updateView: function(filterURL) {

    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $(".collection-matrix").addClass('fadeOut animated loading-in-progress filter-loading');
        Waypoint.destroyAll();
      },
      success: function(data) {
          $(".collection-matrix").removeClass('loading-in-progress');
          $(".collection-matrix").removeClass('filter-loading');
          var filteredBreadcrumb = $(data).find('.breadcrumb_text').html();
          $('.breadcrumb_text').html(filteredBreadcrumb);

          var filteredPagination = $(data).find('.paginate').html();
          $('.paginate').html(filteredPagination);

          var filteredSidebar = $(data).find('.sidebar').html();
          $('.sidebar').html(filteredSidebar);

          var filteredPageLinks = $(data).find('.paginate').html();
          $('.paginate').empty();
          $('.paginate').html(filteredPageLinks);

          var filteredData = $(data).find('.collection-matrix');
          $('.collection-matrix').remove();
          filteredData.insertBefore( $('.load-more__icon') );

          window.history && window.history.pushState && window.history.pushState("", "", filterURL);

          if ($('.sidebar__collection-filter').length){
            window.collectionSidebarFilter.init();
          }

          if (Shopify.theme_settings.pagination_type == 'infinite_scroll'){
            enableInfiniteScroll();
          }

          if (window.Currency.show_multiple_currencies) {
            window.currencyConverter.convertCurrencies();
          }

          if (Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges) {
            SPR.$(document).ready(function() {
              return SPR.registerCallbacks(),
              SPR.initRatingHandler(),
              SPR.initDomEls(),
              SPR.loadProducts(),
              SPR.loadBadges()
            })
          }



        // Will reload recently viewed if present
        window.recentlyViewed.init();

        // Re-link swatches on inline quick-shop
        $('.js-product_section .product_form_options').each(function () {
          new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(this).data("enable-state") });
        });

        // Call product functions
        window.productPage.init();
        window.productPage.runOptionSelector();

        // Prevent event bubbling
        $('body').off('click', '.swatch-element');

        // Reload product swatches
        window.productPage.productSwatches();

        //Swatch toggler
        $('.swatch-options input').each(function(){
          if($(this).is(':checked')) {
            window.quickShop.toggleSwatchImages($(this));
          }
        });

        $('.swatch-options label').on('click', function(){
          window.quickShop.toggleSwatchImages($(this));
        });

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

      },
      dataType: "html"
    });
  },
  processUrl: function(path, tags, query){

    var query = query.replace(/\page=(\w+)&/, ''),
        urlString = '';

    urlString = path + tags + query;

    quickFilter.updateView(urlString);

  }
}


/*============================================================================
  Search autocomplete
==============================================================================*/

window.searchAutocomplete = {
  vars: {
    term: '',
    searchPath: Shopify.routes.search_url,
    displayTimer: ''
  },
  init: function(){

    this.unload();

    // Focus state to display search results
    $('[data-autocomplete-true]').on('focus', function() {
      $(this).parents('[data-autocomplete-true]').find('.search__results-wrapper').show();
    });

    // Clicking outside makes the results disappear.
    $(document).on('click focusout', function(e) {
      if (Shopify.media_queries.large.matches) {
        var searchForm = $(e.target).parents('.search__form');

        if (searchForm.length === 0 && $(window).width() <= 798) {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
        }
      }
    });

    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').on('click touchstart', function(e) {
      if (Shopify.media_queries.medium.matches) {
        e.stopPropagation();
        var formType = $(this).closest('form').find('[name="type"]').val();
        var position = $(document).scrollTop();
        window.searchAutocomplete.showMobileSearch(formType, position);
      }
    });

    $('.search-close').on('click touchstart', function() {
      $('body').removeClass('is-active');
      $('.dropdown_link').removeClass('active_link');
      $('.dropdown_container').hide();
      $('.mobile_nav').find('div').removeClass('open');
      $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
    })

    // Submit wildcard searches
    $("[data-autocomplete-true] form").on("submit", function(e) {
      e.preventDefault();
      var formValue = $(this).find('input[name="q"]').val();
      var cleanFormValue = encodeURI(formValue);

      if ($(this).find('[name="type"]').length > 0) {
        var searchType = $(this).find('[name="type"]').val();
      } else {
        var searchType = Shopify.theme_settings.search_option;
      }

      if (cleanFormValue == null) {
        window.location.href = Shopify.routes.search_url + '?type=' + searchType;
      } else {
        window.location.href = window.searchAutocomplete.vars.searchPath + '?type=' + searchType + '&q=' + cleanFormValue + '*';
      }
    });

    $('[data-autocomplete-true] form').each(function() {
      var $this = $(this);
      var input = $this.find('input[name="q"]');

      // Adding a list for showing search results.
      $('<div class="search__results-wrapper"><ul class="search__results"></ul></div>').appendTo($this);

      input.attr('autocomplete', 'off').on('input', function() {
        clearTimeout(window.searchAutocomplete.vars.displayTimer);
        if ($(this).val().length > 3) {
          window.searchAutocomplete.vars.term = $(this).val();
          window.searchAutocomplete.getResults(window.searchAutocomplete.vars.term, $this);
        } else {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
        }
      });
    });
  },
  getResults: function(term, $this) {

    if ($this.find('[name="type"]').length > 0) {
      var searchType = $this.find('[name="type"]').val();
    } else {
      var searchType = Shopify.theme_settings.search_option;
    }

    jQuery.getJSON("/search/suggest.json", {
      "q": term,
      "resources": {
        "type": searchType,
        "limit": Shopify.theme_settings.search_items_to_display,
        "options": {
          "unavailable_products": "last",
          "fields": "title,body,variants.title,vendor,product_type,tag"
        }
      }
    }).done(function(response) {

      var suggestions = [
        response.resources.results.products,
        response.resources.results.pages,
        response.resources.results.articles
      ];

      var filteredResults = [];

      // Store results in array
      $.each(suggestions, function(index, suggestion) {
        if (suggestion !== undefined && suggestion.length > 0) { // Ensure suggestion exists
          filteredResults.push(suggestion)
        }
      })

      // Display results
      window.searchAutocomplete.vars.displayTimer = setTimeout(function() {
        window.searchAutocomplete.displayResults(filteredResults[0], $this);
      }, 500)
    });
  },
  displayResults: function(results, $this) {

    var $resultsWrapper = $this.find('.search__results-wrapper');
    var $resultsList = $this.find('.search__results');
    $resultsWrapper.show();
    $resultsList.empty();

    if ($this.find('[name="type"]').length > 0) {
      var searchType = $this.find('[name="type"]').val();
    } else {
      var searchType = Shopify.theme_settings.search_option;
    }

    if (results && results.length > 0) {
      $.each(results, function(index, result) {

        var link = $('<a tabindex="0"></a>').attr('href', result.url);
        if (Shopify.routes.root_url !== '/') {
          link = $('<a tabindex="0"></a>').attr('href', Shopify.routes.root_url + result.url);
        }

        // If result is a product
        if (result['price']) {

          function formatPrice(price) {
            return '<span class="money">' + Shopify.formatMoney(price, $('body').data('money-format')) + '</span>';
          }

          if (result.available === true) {
            if (result.compare_at_price_max > result.price_max || result.compare_at_price_min > result.price_min ) {
              var itemPrice = formatPrice(result.price) + ' <span class="was_price">' + formatPrice(result.compare_at_price_max) + '</span>';
            } else {
              if (result.price > 0) {
                if (result.price_min != result.price_max) {
                  var itemPrice = Shopify.translation.from_text + ' ' + formatPrice(result.price);
                } else {
                  var itemPrice = formatPrice(result.price);
                }
              } else {
                var itemPrice = Shopify.theme_settings.free_text;
              }
            }
          } else {
            var itemPrice = Shopify.theme_settings.sold_out_text;
          }

          // If result has an image
          if (result['image']) {
            link.append('<div class="thumbnail"><img class="lazyload transition--' + Shopify.theme_settings.image_loading_style + '" src="' + window.utils.addImageDimension(result['image'], '_300x') + '" /></div>');
          }

          link.append('<div class="search-title">' + result.title + '<br><span class="item-pricing price">'+ itemPrice +'</span></div>');

          // If result is an article
        } else if(result['summary_html']) {
          if(result.image != 'NULL') {
            link.append('<div class="thumbnail"><img class="lazyload transition--' +  Shopify.theme_settings.image_loading_style + '" src="' + window.utils.addImageDimension(result['image'], '_300x') + '" /></div>');
          }
          link.append('<div class="search-title">' + result.title + '<br><span class="item-description">'+ result.summary_html.replace(/(<([^>]+)>)/ig,"").slice(0, 25) +' </span></div>');

          // If result is a page
        } else if(result['published_at']) {
          link.append('<div class="search-title">' + result.title + '<br><span class="item-description">'+ result.body.replace(/(<([^>]+)>)/ig,"").slice(0, 25) +' </span></div>');

        }

        // Wrap link and append to list
        link.wrap('<li class="item-result"></li>');
        $resultsList.append(link.parent());
      });

      $resultsList.prepend('<li class="all-results"><span class="search-title see-all"><a href="' + this.vars.searchPath + '?type=' + searchType + '&q=' + this.vars.term + '*"><span>' + Shopify.translation.all_results + '</span></a></span></li>');

      if (window.Currency.show_multiple_currencies || window.Currency.native_multi_currency) {
        window.currencyConverter.init();
      }

      $resultsList.parents('.search__results-wrapper').addClass('results-found');

    } else {
      // if no results
      var noResults = '<li class="item-result"><span class="no-results search-title">' + Shopify.translation.no_results + '</span></li>';
      $resultsList.append(noResults);
      $resultsList.parents('.search__results-wrapper').removeClass('results-found');
    }

    $resultsList.show();
  },
  showMobileSearch: function(formType, position) {
    $('body').css('max-height', window.innerHeight);

    $('.mobile-search').fadeIn(200);

    if(/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      $('.mobile-search input#q').focus();
    } else {
      //Set delay to ensure focus triggers on android
      setTimeout(function() {
        $('.mobile-search input#q').focus();
      }, 205);
    }

    document.body.style.position = 'fixed';
    document.body.style.top = '-' + position + 'px';
    $('.mobile-search').css('top', position)

    var searchHeight = window.innerHeight - 60; //Full screen height - form height
    $('.mobile-search .search__results-wrapper').css('max-height', searchHeight)

    if (formType) {
      $('.mobile-search [name="type"]').val(formType);
    } else {
      $('.mobile-search [name="type"]').val(Shopify.theme_settings.search_option);
    }

    $('.search-form .close-search').on('click touchstart', function(e) {
      e.preventDefault();
      e.stopPropagation();
      window.searchAutocomplete.hideMobileSearch(position);
      $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
    });

    $('.search-form .submit-search').on('click touchstart', function(e) {
      $(this).parents('form').submit();
    });
  },
  hideMobileSearch: function(position) {
    $('body').css('max-height', 'none');

    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, position);

    $('.mobile-search').fadeOut(200);
    $('.mobile-search [name="q"]').val('');

    $('body').off('focus', '.search-form .close-search');
    $('body').off('focus', '.search-form .submit-search');
  },
  unload: function() {
    $('body').off('focus', '[data-autocomplete-true] input');
    $('input[name="q"]').off();
    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off();
    $('.search__results-wrapper').remove();
  }
}

/*============================================================================
  Sidebar filter on collection pages
==============================================================================*/

window.collectionSidebarFilter = {
  init: function(){

    $('.filter-active-tag input:checked').parents('.filter-active-tag').siblings('.filter-all-tags').hide();
    $('.toggle-all--true .toggle_list .filter-active-tag input:checked').parents('ul.toggle_list').prev().click();

    //checks if there is an active filter, and if so, to keep the tag filter dropdown open
    var queryString = window.location.search;
    if (queryString.indexOf("sort_by") > 0 && $('.toggle-all--true .toggle_list .filter-active-tag input').attr('checked')) {
      $('.sidebar__collection-filter > h4').addClass('active')
    }

    //Hide filters if types or vendors is in URL (can't be combined)
    if ($.url(2) === 'types' || $.url(2) === 'vendors'){
      $('.sidebar__collection-filter').remove();
    }

    $('.sidebar-block:empty').prev().css('border-bottom', 'none');

    //Will reload recently viewed if present
    window.recentlyViewed.init();
  },
  clearAllFilters: function(){
    $('[data-option-filter] input').prop('checked', false);
    $('[data-option-filter] input').trigger('change');

    //Will reload recently viewed if present
    window.recentlyViewed.init();
  },
  clearSelectedFilter: function(optionFilter){
    // if the sidebar tag that is being cleared matched the tag inside of the tag filter dropdown, reset the dropdown value to it's default value
    if ($('#tag_filter').length) {
      if (optionFilter.find('[data-option-filter] input').val() === $('#tag_filter option:selected ').val().substr($('#tag_filter option:selected ').val().lastIndexOf('/') + 1)) {
        $('#tag_filter').val($('#tag_filter option:first').val())
      }
    }

    optionFilter.find('[data-option-filter] input').prop('checked', false);
    optionFilter.find('[data-option-filter] input').trigger('change');

    //Will reload recently viewed if present
    window.recentlyViewed.init();
  }
}




/*============================================================================
  Misc
==============================================================================*/
if (Shopify.theme_settings.slideshow_arrow_size == 'bold'){
  window.arrowSize = {
    x0: 10,
    x1: 40, y1: 50,
    x2: 80, y2: 50,
    x3: 50
  }
  window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow"></path></svg>'
  window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
} else if (Shopify.theme_settings.slideshow_arrow_size == 'light'){
  window.arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 62, y2: 40,
    x3: 22
  }
  window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>'
  window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
} else if (Shopify.theme_settings.slideshow_arrow_size == 'regular'){
  window.arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  }
  window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>'
  window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
}

window.isScreenSizeLarge = function isScreenSizeLarge() {
  if (window.matchMedia( "(min-width: 1024px)" ).matches) {
    return true;
  }
}

window.utils = {
  createAccordion: function(container, tab, content){
    var $container = $(container);
    var $tab = $(container).find(tab);
    var $content = $(container).find(content);
    var specificTab = container + ' ' + tab;

    //Check to see if need to rearrange product tabs to create accordion (backwards compatible)
    if (container.indexOf(".accordion-tabs") >= 0){
      var rearrangedTabs = $.map($tab, function(v, i) { return [v, $content[i]]; });
      $container.empty();

      $.each(rearrangedTabs, function (index, value) {
        $container.append(this);
      });

      $content.removeClass('active');
      $container.find('.active').next().slideToggle();

      tab = container + '> a';
    }

    $(container).children('a').each(function(i, tab) {
      var tab = $(this);
      var tabValue = tab.attr('href'); //get tab id
      tab.attr('data-tab-value', tabValue); //set tab id in data attribute
      tab.removeAttr("href"); //remove href (to prevent url hash update)
    });

    $(container).find(tab + '.active').next().slideToggle();
    $('body').on('click', specificTab, function(e){
      e.preventDefault();
      $('.collection-page .toggle').not(this).removeClass('active');
      $('.collection-page .toggle').not(this).next().fadeOut(200);
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  mobileAccordion: function(container, tab, content){
    $container = $(container);
    $tab = $(container).find(tab);
    $content = $(container).find(content);

    $(tab + '.active').next().slideToggle();

    $('body').on('click', tab, function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  mobileParentActiveAccordion: function(container, tab, content){
    $container = $(container);
    $tab = $(container).find(tab);
    $content = $(container).find(content);

    $(tab + '.active').parent().next().slideToggle();

    $('body').on('click', tab, function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().next().slideToggle();
    });
  },
  initializeTabs: function(){
    $('ul.tabs > li > a').attr('data-no-instant', true);
    $('body').on('click', 'ul.tabs > li > a', function(e) {
      e.preventDefault();
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        $('ul.tabs > li > a.active').removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  },
  productReviewScroll: function(){
    if ($('#shopify-product-reviews').length && $('.shopify-product-reviews-badge').length) {
      $('.spr-badge-container').on('click', function () {
        window.utils.scrollToTop('#shopify-product-reviews');
      });
    }
  },
  scrollToTop: function(element, height){
    // Check if height argument is present
    if(height != undefined) {
      $('html, body').animate({
        scrollTop: $(element).offset().top - height
      }, 1000);
    } else {
      $('html, body').animate({
        scrollTop: $(element).offset().top
      }, 1000);
    }
  },
  pageBannerCheck: function(){
    //check for header banner
    if (!$('.page-banner').length > 0 || $('.header').hasClass('header-background--solid')) {
      $('.feature_image').removeClass('feature_image');
      $('.header.is-absolute').removeClass('is-absolute');
      //hide secondary logo
      $('.secondary_logo--true').find('.secondary_logo').css('display', 'none');
      $('.secondary_logo--true').find('.primary_logo').css('display', 'block');
    } else {
      if ($('.page-banner').hasClass('full-width--true')) {
        $('.header').parent().addClass('feature_image');
        $('.header').addClass('is-absolute');
        //check for secondary logo
        if ($('header.feature_image').hasClass('secondary_logo--true')){
          $('.secondary_logo--true').find('.secondary_logo').css('display', 'block');
          $('.secondary_logo--true').find('.primary_logo').css('display', 'none');
        }
      } else {
        $('.header').parent().removeClass('feature_image');
        $('.header').removeClass('is-absolute');
      }
    }

    //check for section that uses header banner on home page
    if ($('.index-sections').children().first('.under-menu').find('.full-width--true').length) {
      if (!$('.header').hasClass('header-background--solid')) {
        $('.index .header').parent().addClass('feature_image');
        $('.index .header').addClass('is-absolute');
      }
      //check for secondary logo
      if ($('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').show();
        $('.secondary_logo--true').find('.primary_logo').hide();
      }
    } else {
      $('.index .feature_image').removeClass('feature_image');
      $('.index .header.is-absolute').removeClass('is-absolute');
      //hide secondary logo
      if (!$('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').hide();
        $('.secondary_logo--true').find('.primary_logo').show();
      }
    }

    //check for section that uses header banner on the page details template
    if ($('.detail-sections').children().first().hasClass('under-menu')) {
      if (!$('.header').hasClass('header-background--solid')) {
        $('[class^="page-details"] .header').parent().addClass('feature_image');
        $('[class^="page-details"] .header').addClass('is-absolute');
      }

      //check for secondary logo
      if ($('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').show();
        $('.secondary_logo--true').find('.primary_logo').hide();
      }
    } else {
      $('[class^="page-details"] .feature_image').removeClass('feature_image');
      $('[class^="page-details"] .header.is-absolute').removeClass('is-absolute');

      //hide secondary logo
      if (!$('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').hide();
        $('.secondary_logo--true').find('.primary_logo').show();
      }
    }
  },
  enableDisclosure: function() {

    var $disclosure = $('[data-disclosure]');
    var $toggle = $('[data-disclosure-toggle]');
    var $disclosureWrap = $('.disclosure__list-wrap');

    //Check if current opened menu is offscreen
    function checkOffScreen($openedToggle) {
      if($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }

    function closeDisclosures(ignoreTarget, currentTarget) {
      if(ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }

      $disclosureWrap.removeClass('disclosure--left');
    }

    //Close menus on ESC
    $('body').on('keyup', function(e) {
      if(e.which == '27') {
        closeDisclosures();
      }
    });

    //Close menus on hoverout
    $disclosure.on('mouseleave', function(e) {
      closeDisclosures();
    });

    //On click/focus event for toggling options
    $toggle.on('mouseenter focus', function(e) {
      //Close all other menus
      closeDisclosures(true, this);

      var $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    });

    //When tabbing through, close dropdown when tabbing out of dropdown
    $('.disclosure__button').on('focusout', function(e) {
      //Close all other menus
      if(!$(e.relatedTarget).hasClass('disclosure__button') || $(e.relatedTarget).hasClass('disclosure__toggle')) {
        closeDisclosures();
      }
    });

    //Mobile toggle logic
    $toggle.on('touchstart', function(e) {
      if (Shopify.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        var $target = $(e.currentTarget);

        closeDisclosures(true, this);

        if(!$target.hasClass('is-clicked')) {
          $target.attr('aria-expanded', 'true').addClass('is-clicked');
          checkOffScreen($target);
        } else {
          $target.attr('aria-expanded', 'false').removeClass('is-clicked');
          $disclosureWrap.removeClass('disclosure--left');
        }
      }
    })

  },
  addImageDimension: function(imageUrl, size) {
    var insertPosition = imageUrl.lastIndexOf(".");
    return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
  },
  unload: function($target){
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
  }
}

window.sliderBlock = {
  select: function(blockId, $parentSection){
    var $blocks = $parentSection.find('.gallery-cell');
    var blockIdsArray = $blocks.map(function() {
      return String($(this).data('block-id'));
    });

    var $slider = $parentSection.find('[data-slider-id]');
    var settings = {
      slideshowTextAnimation: $slider.data('slideshow-text-animation')
    }
    var flkty = $slider.data('flickity');

    $slider.flickity('pausePlayer');

    for(var i = 0; i < blockIdsArray.length; i++){
      if(blockIdsArray[i] === blockId){
        var currentSlide = i;
        if (currentSlide !== flkty.selectedIndex){
          $slider.flickity( 'select', parseInt(currentSlide), false, true);
        }
      }
    }
  },
  deselect: function($parentSection){
    var $slider = $parentSection.find('.flexslider').data('flexslider');
    if($slider) {
      $slider.flickity('unpausePlayer');
    }
  }
}

/*============================================================================
  Quick shop
==============================================================================*/

var globalQuickShopProduct;

window.quickShop = {
  init: function(){

    //EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', e => {
      e.preventDefault();

      const $currentTarget = $(e.currentTarget);

      window.productPage
        .loadQuickshop($currentTarget.data('url'))
        .then(data => {
          if (!data) { return; }
          const html = data.html;
          $('.js-quick-shop').html(html.content);

          if (!$('.fancybox-active').length) {
            $.fancybox.open($('.js-quick-shop'), {
              baseClass: `quick-shop__lightbox product-${$currentTarget.data('id')}`,
              hash: false,
              infobar : false,
              toolbar: false,
              loop: false,
              smallBtn : true,
              video: {
                autoStart: false
              },
              touch: false,
              mobile: {
                preventCaptionOverlap: false,
                toolbar: true,
                buttons: [
                  "close"
                ]
              },
              beforeLoad: () => {
                window.productPage.init();
                window.productPage.runOptionSelector();
                videoFeature.setupVideoPlayer();
                productMedia.setupMedia();
                utils.initializeTabs();
                productPage.productSwatches();

                if (Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }
              },
              afterShow: (_e, instance) => {
                // Use unique identifier for the product gallery
                const { src } = instance;
                const $quickshop = $(src).find('.quick-shop');

                $quickshop.addClass('quick-shop--loaded');
                $quickshop.addClass('content-loaded');
              },
              beforeClose: (_e, instance) => {
                // Use unique identifier for the product gallery
                const { src } = instance;
                const $quickshop = $(src).find('.quick-shop');

                $quickshop.removeClass('quick-shop--loaded');
                $quickshop.removeClass('content-loaded');
              }
            });
          }
        }).catch(error => console.error(error))
    });

    // Swatch toggler
    $('.swatch-options input').each(function() {
      if($(this).is(':checked')) {
        window.quickShop.toggleSwatchImages($(this));
      }
    });

    $('.swatch-options label').on('click', function(){
      window.quickShop.toggleSwatchImages($(this));
    });
  },
  toggleSwatchImages: function(swatchInput) {
    var swatchImageID = $(swatchInput).data('image');
    var $quickShopElement = $(swatchInput).parents('.thumbnail').find('.image__container img');

    $quickShopElement.attr('src', swatchImageID);
    $quickShopElement.attr('srcset', swatchImageID);
  }
}

/*============================================================================
  Newsletter Popup
==============================================================================*/

window.newsletter_popup = {
  init: function(){
    var popup = window.Cookies.get('popup');
    var newsletter_popup_days = parseInt(Shopify.theme_settings.newsletter_popup_days);
    var cookie_enabled = newsletter_popup_days != 0 ? true : false;
    if (cookie_enabled && popup == 'open') {
      return false;
    } else {
      window.newsletter_popup.open();
    }
    if (cookie_enabled) {
      window.Cookies.set('popup', 'open', { expires: newsletter_popup_days, path: '', domain: '', sameSite: 'None', secure: true });
    }
  },
  open: function(){
    var newsletter_popup_seconds = parseInt(Shopify.theme_settings.newsletter_popup_seconds);

    if (Shopify.theme_settings.newsletter_popup_mobile || Shopify.media_queries.large.matches) {
      setTimeout( function() {
        $.fancybox.open($('.js-newsletter-popup'), {
          baseClass: 'newsletter__lightbox',
          hash: false,
          infobar : false,
          toolbar: false,
          loop: true,
          smallBtn : true,
          mobile: {
            preventCaptionOverlap: false,
            toolbar: true,
            buttons: [
              "close"
            ]
          }
        });
      },
      newsletter_popup_seconds * 1000);
    }
  }
}

/*============================================================================
Product media controls
==============================================================================*/

window.productMedia = {
  models: [],
  setupMedia: function() {
    var config = {
      // Default control list
      controls: [
        'zoom-in',
        'zoom-out',
        'fullscreen'
      ],
      focusOnPlay: false
    }

    $($('model-viewer', $('.js-product-gallery, .js-gallery-modal'))).each(function(index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      window.productMedia.models.push(model)
    })

    $('.product-gallery__model model-viewer').on('mousedown',function(){
      window.productMedia.hideModelIcon(this);
    })
  },
  showModelIcon: function(slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function(slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
}

/*============================================================================
Plyr setup
==============================================================================*/

window.videoEl = {
  playButtonIcon:'<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
}

window.videoControls = window.videoEl.playButtonIcon + '<div class="plyr__controls">' + window.videoEl.playButton + window.videoEl.progressInput + window.videoEl.muteButton + videoEl.volume + window.videoEl.fullscreen + '</div>';
window.globalVideoPlayers = [];
window.videoPlayers = [];
window.videosInRecommendedProductsPlayer;

window.videoFeature = {
  init: function() {

    this.setupVideoPlayer();
    this.setupRecommendedVideoPlayer();

  },
  setupVideoPlayer: function() {
    var productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');

    var setupVideoPlayers = Plyr.setup(productVideos, {
      controls: window.videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });

    // Moves players into global array so that we can target them for play/pause on global level
    if (window.globalVideoPlayers) {
      $.each(setupVideoPlayers, function(index, player) {
        window.globalVideoPlayers.push(player);
      })
    }

    var videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, function(index, player) {
      player.loop = videoLooping;
      window.videoPlayers.push(player);
    });

    this.setupListeners();
  },
  setupPlayerForRecentlyViewedProducts: function(video) {

    if (video) {
      var recentlyViewedProductPlayer = new Plyr(video, {
        controls: window.videoControls,
        ratio: this.aspect_ratio,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });

      if (window.videoPlayers !== null) {
        window.videoPlayers.push(recentlyViewedProductPlayer);
        this.setupListeners();
      }

    }
  },
  setupRecommendedVideoPlayer: function() {
    var videosInRecommendedProducts = document.querySelectorAll('.product-recommendations [data-html5-video] video, .product-recommendations [data-youtube-video]');

    // Only run Plyr.setup if videosInRecommendedProducts exists
    if (videosInRecommendedProducts.length > 0) {
      window.videosInRecommendedProductsPlayer = Plyr.setup(videosInRecommendedProducts, {
        controls: window.videoControls,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      if (window.videoPlayers !== null) {
        var combinedArray = window.videoPlayers.concat(window.videosInRecommendedProductsPlayer);
        window.videoPlayers = combinedArray;
      } else {
        window.videoPlayers = videosInRecommendedProductsPlayer;
      }
    }

    this.setupListeners();
  },
  setupListeners: function() {
    // Adds plyr video id to video wrapper
    $.each(window.videoPlayers, function(index, player) {
      var id = player.id || player.media.dataset.plyrVideoId;
      var $video;

      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      }
    })

    // When a video is playing, pause any other instances
    $.each(window.globalVideoPlayers, function(index, player) {
      player.on('play', function(event) {
        var instance = event.detail.plyr;
        $.each(window.globalVideoPlayers, function(index, player) {
          if (instance.id != player.id ) {
            player.pause();
          }
        })
      })
    })
  },
  enableVideoOnHover: function($thumbnail) {

    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(window.videoPlayers, function(index, player) {

        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      })
    }
  },
  disableVideoOnHover: function($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(window.videoPlayers, function(index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      })
    }
  }
}

/*
# Variables
# Function to get the element exists
# Pop-up
  # Data
  # Videos
  # Upsell product
  # Size guide
# Discounts
# Set current year
# Get a product image height
# Doesn't use passive listeners to improve scrolling performance
# Change button text for Newsletter form (temporary solution)
# Show the message with savings amount
# Turn off the crossed-out colors displayed on product cards
# Show product variants on hover
# Solution for color variant options
# Rio media gallery solution
# Banner card solution for mobile phones
# CF Insider's Club
# Smooth scroll to anchor
# Accessibility
# Circled logos
# Navigation
# Sidebar
# Preload
# Mini cart
# Variants selection functionality (mobile)
# Remove the href attribute from the main menu on touch devices
# Media Library
# Free Gift With Purchase
  # Size guide
  # Size selector
# Remove the Newsletter section from the Login page
# Forward swatch will update based on the availability of the previous option "sold-out" selected
# Product swatch will update based on the availability at least one size option
# Change the select dropdown width depending to children elements width
# Customize YouTube play button
# Search window on the desktop
# Log-in page
# Quantity limit of items on landings page
# Delivery Address

# Microsites
  # Copper Fit X
    # Header
    # Utility function to update .has-sale-savings class
    # Enable purchase button when a variant is selected

# Landings
  # Quantity limit of items on landings page
  # Pixels

# Strengthen the users password
# Hide the BIS button on Medical Grade Compression Socks (temporary solution)
*/

// # Variables
const isMobile = $(window).width() <= 540;
const isTabletPortrait = $(window).width() <= 820;
const isWideScreen = $(window).width() > 798;
const isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))

// # Function to get the element exists
var isEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      isEl(selector, callback);
    }, 1);
  }
};

// # Pop-up
function closePopUp() {
  $('.pop-up').fadeOut(500).children('.pop-up__content').empty();
}

$('.pop-up__close').click(function() {
  closePopUp();
});

$(document).mouseup(function(e) {
  var popUpContent = $('.pop-up__content');

  if (!popUpContent.is(e.target) && popUpContent.has(e.target).length === 0) closePopUp();
});

// # Data
let privacyPolicy = $('#privacy-policy');
let termsConditions = $('#terms-conditions');
let contactUs = $('#contact-us');

$('#shopify-section-footer-landing ul li p').click(function() {
  $('.pop-up--data .pop-up__content').empty();

  switch ($(this).data('url')) {
    case 'privacy-policy':
      landingData(privacyPolicy)
      
      break;
    case 'terms-conditions':
      landingData(termsConditions)

      break;
    case 'contact-us':
      landingData(contactUs)
  
      break;
    default:
      
      break;
  }

  $('.pop-up').removeClass('pop-up--variants').addClass('pop-up--data').fadeIn(500);
});

function landingData(data) {
  data.detach();
  $('.pop-up .pop-up__content').append(data);
}

// # Videos
function videoPopUp(src) {
  $('.pop-up').fadeIn(500).children('.pop-up__content').append('<iframe width="1920" height="1080" src="' + src +'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>')
}

$('.video-card__buttons button').click(function() {
  let src = $(this).parents('.video-card').find('iframe').prop('src');

  videoPopUp(src);
});

var videosAndTvSlide = $('.blog-media-library-page__section--videos .swiper-slide a, .blog-media-library-page__section--commercials .swiper-slide a');

videosAndTvSlide.click(function() {
  let src = $(this).find('iframe').prop('src');

  videoPopUp(src);
});

// # Upsell product
let upsellProduct = $('#upsell-product');
let upsellBuyButton = upsellProduct.find('.purchase-details__buttons .global-button');

// Change the button text
upsellBuyButton.children('.text').text('Add To Cart and Get 10% Off');

// Update the selected value for bundle purchase
$('<input>').attr({
  id: 'upsell-value',
  type: 'hidden',
  name: 'items[1][id]'
}).insertAfter('.upsell-product__info .purchase-details')

let bundleFirst;
let bundleSecond;
let upsellValue = $('#upsell-value');

function changeUpsellValue(value) {
  upsellValue.attr('value', value)
}

// Arch Relief Plus
if (window.location.href.indexOf('/products/arch-relief-plus') > -1) {
  changeUpsellValue('41550312571034');

  $('.product-page__information--upsell .swatch-options input').on('change', function() {
    bundleFirst = $('.product-page__information--upsell .swatch[data-option-index="2"] input:checked');
    
    if (bundleFirst.val() === 'Black') changeUpsellValue('41550312571034');
    if (bundleFirst.val() === 'Beige') changeUpsellValue('42486780395674');
  })
}

// Energy Ankle Compression Socks
if (window.location.href.indexOf('/products/energy-ankle-compression-socks') > -1) {
  changeUpsellValue('41331684671642');

  $('.product-page__information--upsell .swatch-options input').on('change', function() {
    bundleFirst = $('.product-page__information--upsell .swatch[data-option-index="1"] input:checked');
    
    if (bundleFirst.val() === 'S/M') changeUpsellValue('41331684671642');
    if (bundleFirst.val() === 'L/XL') changeUpsellValue('41331684704410');
  })
}

// Elite Knee Sleeve
if (window.location.href.indexOf('/products/elite-knee-sleeve') > -1) {
  changeUpsellValue('41189593251994');

  $('.product-page__information--upsell .swatch-options input').on('change', function() {
    bundleFirst = $('.product-page__information--upsell .swatch[data-option-index="1"] input:checked');
    
    if (bundleFirst.val() === 'S/M') changeUpsellValue('41189593251994');
    if (bundleFirst.val() === 'L/XL') changeUpsellValue('41189593284762');
  })
}

// Energy Crew Compression Socks
if (window.location.href.indexOf('/products/energy-crew-compression-socks') > -1) {
  changeUpsellValue('41331708002458');

  $('.product-page__information--upsell .swatch-options input').on('change', function() {
    bundleFirst = $('.product-page__information--upsell .swatch[data-option-index="1"] input:checked');

    if (bundleFirst.val() === 'S/M') changeUpsellValue('41331708002458');
    if (bundleFirst.val() === 'L/XL') changeUpsellValue('41331708035226');
  })
}

// Zen Step Insoles
if (window.location.href.indexOf('/products/zen-step-insoles') > -1) {
  changeUpsellValue('41550955675802');
  
  $('.product-page__information--upsell .swatch-options input').on('change', function() {
    bundleFirst = $('.product-page__information--upsell .swatch[data-option-index="1"] input:checked');

    if (bundleFirst.val() === "Men's O/S") changeUpsellValue('41550955675802');
    if (bundleFirst.val() === "Women's O/S") changeUpsellValue('41916214968474');
  })
}

// Women's Core Shaper
if (window.location.href.indexOf('/products/womens-core-shaper') > -1) {
  changeUpsellValue('42499077275802');

  $('.product-page__information--upsell .swatch-options input').on('change', function() {
    bundleFirst = $('.product-page__information--upsell .swatch[data-option-index="1"] input:checked');
    bundleSecond = $('.product-page__information--upsell .swatch[data-option-index="2"] input:checked');

    if (bundleFirst.val() === 'S/M' && bundleSecond.val() === 'Charcoal') changeUpsellValue('42499077275802');
    if (bundleFirst.val() === 'S/M' && bundleSecond.val() === 'Beige') changeUpsellValue('42499050537114');

    if (bundleFirst.val() === 'L/XL' && bundleSecond.val() === 'Charcoal') changeUpsellValue('42499077341338');
    if (bundleFirst.val() === 'L/XL' && bundleSecond.val() === 'Beige') changeUpsellValue('42499077308570');
  })
}

// Advanced Back Pro
if (window.location.href.indexOf('/products/advanced-back-pro') > -1) {
  changeUpsellValue('40534182068378');

  $('.product-page__information--upsell .swatch-options input').on('change', function() {
    bundleFirst = $('.product-page__information--upsell .swatch[data-option-index="1"] input:checked');

    if (bundleFirst.val() === 'S/M') changeUpsellValue('40534182068378');
    if (bundleFirst.val() === 'L/XL') changeUpsellValue('40534182101146');
    if (bundleFirst.val() === '2X/3X') changeUpsellValue('41524504363162');
  })
}

// Ice Compression Knee Sleeve
if (window.location.href.indexOf('/products/ice-compression-knee-sleeve') > -1) {
  changeUpsellValue('40534182330522');
  
  $('.product-page__information--upsell .swatch-options input').on('change', function() {
    bundleFirst = $('.product-page__information--upsell .swatch[data-option-index="0"] input:checked');
    bundleSecond = $('.product-page__information--upsell .swatch[data-option-index="1"] input:checked');

    if (bundleFirst.val() === '1 Sleeve' && bundleSecond.val() === 'S/M') changeUpsellValue('40534182330522');
    if (bundleFirst.val() === '1 Sleeve' && bundleSecond.val() === 'L/XL') changeUpsellValue('40534182363290');
    if (bundleFirst.val() === '1 Sleeve' && bundleSecond.val() === '2X') changeUpsellValue('41524475953306');
    if (bundleFirst.val() === '1 Sleeve' && bundleSecond.val() === '3X') changeUpsellValue('41524475986074');

    if (bundleFirst.val() === '3 Sleeves' && bundleSecond.val() === 'S/M') changeUpsellValue('41138659786906');
    if (bundleFirst.val() === '3 Sleeves' && bundleSecond.val() === 'L/XL') changeUpsellValue('41138659852442');
    if (bundleFirst.val() === '3 Sleeves' && bundleSecond.val() === '2X') changeUpsellValue('42248980201626');
    if (bundleFirst.val() === '3 Sleeves' && bundleSecond.val() === '3X') changeUpsellValue('42248981217434');
  })
}

// Hand Relief Compression Gloves
if (window.location.href.indexOf('/products/hand-relief-compression-gloves') > -1) {
  changeUpsellValue('40534181609626');

  $('.product-page__information--upsell .swatch-options input').on('change', function() {
    bundleFirst = $('.product-page__information--upsell .swatch[data-option-index="1"] input:checked');

    if (bundleFirst.val() === 'S/M') changeUpsellValue('40534181609626');
    if (bundleFirst.val() === 'L/XL') changeUpsellValue('40534181707930');
    if (bundleFirst.val() === '2X') changeUpsellValue('41524489715866');
  })
}

let detachedUpsellProduct = $('#upsell-product');

isEl('.upsell-product .flickity-enabled', function() {
  detachedUpsellProduct.clone();

  $('.upsell-banner').click(function() {
    $('.pop-up').removeClass('pop-up--data').addClass('pop-up--upsell').fadeIn(500);

    if ($('.pop-up--upsell').find('.pop-up__wrapper').length == 0)
      $('.pop-up--upsell').children().wrapAll('<div class="pop-up__wrapper"></div>');

    $('.pop-up--upsell .pop-up__content').append(detachedUpsellProduct);

    upsellProduct.show();
  });
}, 1000)

// # Size guide
$(document).ready(function() {
  $('#size-guide').detach().appendTo('#size-guide-placeholder');
});

let inputColor = $('.swatch-options .input-color');

inputColor.click(function() {
  inputColor.removeClass('active');
  $(this).addClass('active');
});

function isVarinatWizard() {
  if ($('#size-guide').find('.second').length !== 0) {
    if (!inputColor.first().hasClass('active')) {
      return true;
    }
  }
};

$('.size-guide span').click(function() {
  let sizeGuideImage;

  if ($(window).width() > 798) {
    sizeGuideImage = $(this).siblings('.desktop').not('.second').clone();

    if (isVarinatWizard()) {
      sizeGuideImage = $(this).siblings('.desktop.second').clone();
    };
  } else {
    sizeGuideImage = $(this).siblings('.mobile').not('.second').clone();

    if (isVarinatWizard()) {
      sizeGuideImage = $(this).siblings('.mobile.second').clone();
    };
  }

  $('.pop-up').removeClass('pop-up--upsell').addClass('pop-up--data').fadeIn(500).find('.pop-up__content').append(sizeGuideImage);
});

// # Discounts
let discountValueOne = 'K7KEA1WCK4NQ';
let discountValueTwo = 'A04HVBGZK24S';
let discountValueThree = 'SQBDY49DAGHL';
let discountValueFour = 'H38GLS74HDNZ';
let discountValueFive = 'NVG37AK4MDHA';
let discountValueSix = 'LJKH3478DSBN';
let discountValueSeven = 'BRFD98BDOQKA';
let discountValueEight = '3S3LVNQIGB3N';
let discountValueNine = 'XCNDWU37DF2M';

let miniCartOne = false;
let miniCartTwo = false;
let miniCartThree = false;
let miniCartFour = false;
let miniCartFive = false;
let miniCartSix = false;
let miniCartSeven = false;
let miniCartEight = false;
let miniCartNine = false;

let miniCartUpsell = false;

$('.mini-cart__item-title a').each(function() {
  if ($(this).text().indexOf('Energy Sport Ankle Socks') > 0) miniCartUpsell = true;

  // K7KEA1WCK4NQ
  if ($(this).text().indexOf('Arch Relief Plus') > 0) miniCartOne = true;

  discountCheckMiniCartItems(miniCartOne, miniCartUpsell, discountValueOne)

  // A04HVBGZK24S
  if ($(this).text().indexOf('Energy Ankle Compression Socks') > 0) miniCartTwo = true;

  discountCheckMiniCartItems(miniCartTwo, miniCartUpsell, discountValueTwo)

  // SQBDY49DAGHL
  if ($(this).text().indexOf('Elite Knee Sleeve') > 0) miniCartThree = true;

  discountCheckMiniCartItems(miniCartThree, miniCartUpsell, discountValueThree)

  // H38GLS74HDNZ
  if ($(this).text().indexOf('Energy Crew Compression Socks') > 0) miniCartFour = true;

  discountCheckMiniCartItems(miniCartFour, miniCartUpsell, discountValueFour)

  // NVG37AK4MDHA
  if ($(this).text().indexOf('Zen Step Insoles') > 0) miniCartFive = true;

  discountCheckMiniCartItems(miniCartFive, miniCartUpsell, discountValueFive)

  // LJKH3478DSBN
  if ($(this).text().indexOf("Women's Core Shaper") > 0) miniCartSix = true;

  discountCheckMiniCartItems(miniCartSix, miniCartUpsell, discountValueSix)

  // BRFD98BDOQKA
  if ($(this).text().indexOf('Advanced Back Pro') > 0) miniCartSeven = true;

  discountCheckMiniCartItems(miniCartSeven, miniCartUpsell, discountValueSeven)

  // 3S3LVNQIGB3N
  if ($(this).text().indexOf('Ice Compression Knee Sleeve') > 0) miniCartEight = true;

  discountCheckMiniCartItems(miniCartEight, miniCartUpsell, discountValueEight)

  // XCNDWU37DF2M
  if ($(this).text().indexOf('Hand Relief Compression Gloves') > 0) miniCartNine = true;

  discountCheckMiniCartItems(miniCartNine, miniCartUpsell, discountValueNine)
})

function discountCheckMiniCartItems(counter, upsell, value) {
  if (counter && upsell) {
    if ($('input.js-form-discount[value="' + value + '"]').length < 1)
      $('.cart_content form').append('<input class="js-form-discount" type="hidden" name="discount" value="' + value + '" />');
  } else {
    $('.cart_content form').find('input.js-form-discount[value="' + value + '"]').remove();
  }
}

let cartOne = false;
let cartTwo = false;
let cartThree = false;
let cartFour = false;
let cartFive = false;
let cartSix = false;
let cartSeven = false;
let cartEight = false;
let cartNine = false;

let cartUpsell = false;

$('.shopping-cart__item-title').each(function() {
  if ($(this).text().indexOf('Energy Sport Ankle Socks') >= 0) cartUpsell = true;

  // K7KEA1WCK4NQ
  if ($(this).text().indexOf('Arch Relief Plus') >= 0) cartOne = true;

  discountCheckCartItems(cartOne, cartUpsell, discountValueOne)

  // A04HVBGZK24S
  if ($(this).text().indexOf('Energy Ankle Compression Socks') >= 0) cartTwo = true;

  discountCheckCartItems(cartTwo, cartUpsell, discountValueTwo)

  // SQBDY49DAGHL
  if ($(this).text().indexOf('Elite Knee Sleeve') >= 0) cartThree = true;

  discountCheckCartItems(cartThree, cartUpsell, discountValueThree)

  // H38GLS74HDNZ
  if ($(this).text().indexOf('Energy Crew Compression Socks') >= 0) cartFour = true;

  discountCheckCartItems(cartFour, cartUpsell, discountValueFour)

  // NVG37AK4MDHA
  if ($(this).text().indexOf('Zen Step Insoles') >= 0) cartFive = true;

  discountCheckCartItems(cartFive, cartUpsell, discountValueFive)

  // LJKH3478DSBN
  if ($(this).text().indexOf("Women's Core Shaper") >= 0) cartSix = true;

  discountCheckCartItems(cartSix, cartUpsell, discountValueSix)

  // BRFD98BDOQKA
  if ($(this).text().indexOf('Advanced Back Pro') >= 0) cartSeven = true;

  discountCheckCartItems(cartSeven, cartUpsell, discountValueSeven)

  // 3S3LVNQIGB3N
  if ($(this).text().indexOf('Ice Compression Knee Sleeve') >= 0) cartEight = true;

  discountCheckCartItems(cartEight, cartUpsell, discountValueEight)

  // XCNDWU37DF2M
  if ($(this).text().indexOf('Hand Relief Compression Gloves') >= 0) cartNine = true;

  discountCheckCartItems(cartNine, cartUpsell, discountValueNine)
})

function discountCheckCartItems(counter, upsell, value) {
  if (counter && upsell) {
    if ($('input.js-form-discount[value="' + value + '"]').length < 1)
      $('#cart_form').append('<input class="js-form-discount" type="hidden" name="discount" value="' + value + '" />');
  } else {
    $('#cart_form').find('input.js-form-discount[value="' + value +'"]').remove();
  }
}

// # Set current year
document.getElementById('year').innerHTML = new Date().getFullYear();

// # Get a product image height
$(document).ready(function() {
  let productImageHeight = $(".product_gallery img").height();

  if ($(window).width() > 798)
    $('.product .product_gallery_nav').css('height', productImageHeight);
});

// # Doesn't use passive listeners to improve scrolling performance
$(document).ready(function() {
  jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
      this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
  };

  jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
      this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
  };

  jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
      this.addEventListener("wheel", handle, { passive: true });
    }
  };

  jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
      this.addEventListener("mousewheel", handle, { passive: true });
    }
  };
});

// # Change button text for Newsletter form (temporary solution)
$(document).ready(function() {
  $('.newsletter-info .input-row input[type="submit"]').val('Sign me up!');
});

// # Show the message with savings amount
$(document).ready(function() {
  setTimeout(function() {
    messageWithSavingsAmount();
  }, 500)

  $('body').on('click', '.product-card .swatch-options .swatch[data-option-index="0"] input:not(:checked) + .swatch-element', function() {
    let productCard = $(this).parents('.product-card'),
        mySavings = productCard.find('.my-savings'),
        isSale = false;

    if ($(this).hasClass('isSavings'))
      isSale = true;

    (isSale) ?
      mySavings.css('display', 'block') :
      mySavings.css('display', 'none');
  });
});

// # Turn off the crossed-out colors displayed on product cards
// # Deal with accessibility issues on product cards
productCardsAccessibility();

// # Show product variants on hover
$(document).on({
  mouseenter: function() {
    let productCard = $(this).parents('.product-card');

    if (productCard.find('.swatch-options').length !== 0 ) {
      productCard.addClass('hover');

      if (productCard.find('.product-details .product-name > p').length !== 0 ) {
        productCard.addClass('hover--description');
      }
    } else {
      productCard.addClass('is-swatch');
    }
  }
}, '.product-card .global-button');

$(document).on({
  mouseleave: function() {
    $(this).removeClass('hover hover--description is-swatch');
  }
}, '.product-card');

// # Solution for color variant options
$('body').on('click', '.product-card .color-variant-options .color-swatch .swatch-element', function() {
  $(this).parent().find('.swatch-element').removeClass('select').addClass('unselect');
  $(this).removeClass('unselect').addClass('select');
});

// # Rio media gallery solution
$('body').on('click', '.rio-media-gallery .rio-hide-scrollbar > .rio-hide-scrollbar > div > div', function() {
  $(this).closest('.rio-hide-scrollbar').find('img').css('opacity', '.7');
  $(this).find('img').css('opacity', '1');
});

isEl('.product_gallery_nav .flickity-slider .gallery-cell', function() {
  $('.product_gallery_nav .flickity-slider .gallery-cell').length < 5 ? $('.product_gallery_nav .flickity-slider').addClass('translateZero') : null;
});

// # Banner card solution for mobile phones
if (window.location.href.indexOf('/collections/all') || window.location.href.indexOf('/collections/bestsellers') > -1) {
  if ($(window).width() <= 798) {

    /* TODO: uncomment below if we need a double-wide box on the mobile version */
    // $('.banner-card:not(.banner-card--grid)').remove();
  }
}

// # CF Insider's Club
const insidersPage = $('.insiders-club .section .container');

const insidersFirstStep = $('.insiders-club .first-step');
const insidersSecondStep = $('.insiders-club .second-step');
const insidersThirdStep = $('.insiders-club .third-step');

const signMeUpButtonFirst = 'button[type="button"].needsclick.go1976669375';
const signMeUpButtonSecond = 'button[type="button"].needsclick.go2881893036';
const noThanksButton = 'button[type="button"].needsclick.go1836112351';

isEl('.klaviyo-form > .klaviyo-form', function() {
  insidersPage.addClass('fadeInDown');
});

$(document).on('click', signMeUpButtonFirst, function() {
  if ($(this).hasClass('klaviyo-spinner')) {
    isEl(signMeUpButtonSecond, function() {
      insidersFirstStep.addClass('hide');
      insidersSecondStep.removeClass('hide').addClass('show');
    })
  }
});

$(document).on('click', signMeUpButtonSecond, function() {
  if ($(this).hasClass('klaviyo-spinner'))
    switchSteps();
});

$(document).on('click', noThanksButton, function() {
  switchSteps();
});

function switchSteps() {
  insidersSecondStep.addClass('hide');

  setTimeout(function() {
    insidersThirdStep.removeClass('hide').addClass('show fadeIn');
  }, 500);
}

// # Smooth scroll to anchor
if (!(window.location.href.indexOf('/account') > -1)) {
  const windowHash = window.location.hash || '';

  if (windowHash !== '#' && windowHash !== '#!' && windowHash.length > 0) {  
    smoothScroll(windowHash)
  }

  $(document).on('click', 'a[href*="#"]:not([data-no-instant])', function() {
    setTimeout(function() {
      const onClickWindowHash = window.location.hash || '';
    
      smoothScroll(onClickWindowHash)
    }, 100)
  });

  function smoothScroll(target) {
    let headerHeight;
    let defaultIndentation = 10;

    ($(window).width() <= 798) ? headerHeight = 60 : headerHeight = 68;

    $('html, body').delay(250).animate({
      scrollTop: $("[id^='" + target + "']").offset().top - headerHeight - defaultIndentation
    }, 1000);
  }
}

// # Accessibility
setTimeout(function() {
  let searchContainer = $('.header .search-container');
  let dropdownContainer = $('.header .dropdown');

  searchContainer.find('label[for="scrollSearchField"').attr('for', 'searchField');
  searchContainer.find('#scrollSearchField').attr('id', 'searchField');

  dropdownContainer.find('label[for="dropdownSearchField"').attr('for', 'mobileDropdownSearchField');
  dropdownContainer.find('#dropdownSearchField').attr('id', 'mobileDropdownSearchField');

  $('iframe').attr('aria-hidden', 'true');
  $('img[src*="https://t.co/i/"], img[src*="https://analytics.twitter.com/i/adsct"]').attr('alt', '');

  let recommendetProductCards = $('.recommended-products--slider .product-card.quick-shop-disabled, .featured-collection-section .product-card.quick-shop-disabled');

  recommendetProductCards.find('.shopify-product-form > .select').remove();
  recommendetProductCards.find('.shopify-product-form .swatch input').remove();
}, 1000);

isEl('.sticky_nav', function() {
  $('.sticky_nav .cart-container .cart_content').remove();
  isWideScreen ? $('#header').remove() : $('.header').remove();
})

// # Circled logos
if ($(window).width() > 798) {
  document.querySelectorAll('.circle-section .logo-bar').forEach((circled) => {
    let circles = circled.querySelectorAll('.circle-section .logo-bar__item')
    let angle = 360 - 90, dangle = 360 / circles.length

    for (let i = 0; i < circles.length; ++i ) {
      let circle = circles[i]

      angle += dangle
      circle.style.transform = `rotate(${angle}deg) translate(${circled.clientWidth / 2}px) rotate(-${angle}deg)`
    }
  })
}

// # Navigation
let hideTimeout;

$('.menu li a:contains("Sale")').addClass('sale')

setTimeout(function() {
  $('.main-nav .menu .vertical-menu li').hover(
    function() {
      clearTimeout(hideTimeout);

      $(this).find('.vertical-menu_submenu').stop().addClass('hover').slideDown();
    },
    function() {
      $(this).find('.vertical-menu_submenu').stop().slideUp();
      
      hideTimeout = setTimeout(() => {
        $(this).find('.vertical-menu_submenu').stop().removeClass('hover');
      }, 500);
    }
  )
}, 500)

// # Sidebar
let catalog = $('.collection-page__catalog');

isEl('.clear-active-filter', function() {
  catalog.addClass('banner-card-hided');
})

$('.sidebar').on('click', 'ul li label', function() {
  catalog.addClass('banner-card-hided');
})

$('.sidebar').on('click', '.clear-active-filter', function() {
  if ($('.clear-active-filter').length < 2) {
    catalog.removeClass('banner-card-hided');
  }
})

$('.collection-page__sidebar').on('click', '.toggle-filters', function() {
  $(this).toggleClass('clicked');
  $('.sidebar').toggle(300);
})

// # Preload
setTimeout(function() {
  $('*').removeClass('is-active-preload');
}, 1000)

// # Mini cart
if ($(window).width() <= isTabletPortrait) {
  $('.cart-container').on('click', '.icon-bag, form > a', function() {
    $('html, body').toggleClass('disable-touch-scroll');
  })
  
  if (!$('.mini-cart__item').length > 0)
    $('.mini-cart-info').addClass('hidden');
}

if ($('.mini-cart__item').length > 0) {
  $('.mini-cart-info').removeClass('hidden');
} else {
  $('.js-empty-cart__message').removeClass('hidden');
}

if (window.location.href.indexOf('/cart') > -1)
  $('.cart-container').remove();

// # Variants selection functionality (mobile)
variantsSelection();

// # Remove the href attribute from the main menu on touch devices
if (isTouch) $('.main-nav .menu .vertical-menu li.sublink > a').removeAttr('href');

// # Media Library
$('.blog-media-library-page__section').each(function(i, obj) {
  $(this).find('.swiper-wrapper__nav').detach().appendTo($(this));
})

var videosAndTv = $('.blog-media-library-page__section--videos .swiper-slide, .blog-media-library-page__section--commercials .swiper-slide')

videosAndTv.each(function(i, obj) {
  var src = $(this).find('iframe').attr('src');
  var id = src.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
  var category = $(this).find('.badge').text();
  var title = $(this).find('h3').text();

  if (id.length == 11) {
    var thumbnail = $('<img src="//img.youtube.com/vi/' + id + '/0.jpg" alt="' + title + ' – ' + category + ' section">');
      
    $(this).children('a').prepend(thumbnail);
  }
})

var mediaLibraryPanel = $('.blog-media-library-page__panel div');

$('.blog-media-library-page__panel').on('click', 'p', function() {
  $(this).parent().addClass('selected');
  $('body').css('overflow', 'hidden');
})

mediaLibraryPanel.on('click', 'span', function() {
  $(this).closest('.blog-media-library-page__panel').removeClass('selected');
  $('body').css('overflow', 'auto');

  if ($(this).attr('type') !== 'all') {
    $('.blog-media-library-page__section').hide();
    $('.blog-media-library-page__section--' + $(this).attr("type") + '').show();
  } else {
    $('.blog-media-library-page__section').show();
  }
})

$(document).mouseup(function(e) {
  if (!mediaLibraryPanel.is(e.target) && mediaLibraryPanel.has(e.target).length === 0)
    mediaLibraryPanel.parent().removeClass('selected');

    if ($(window).width() > 798) $('body').css('overflow', 'unset');
});

// # Free Gift With Purchase
let shoppingCartUpsell = $('.shopping-cart__upsell');

$('.shopping-cart__item .remove-text, .shopping-cart__item .product-quantity-box .product-minus').click(function() {
  $('.shopping-cart__checkout-buttons').addClass('disabled');
})

if (window.location.href.indexOf('/cart') > -1) {
  let shoppingCartItem = $('.shopping-cart__list .shopping-cart__item');
  let freeProduct = $('.shopping-cart__item-price:contains("Free")');
  let excludeProduct = $('.shopping-cart__item-title:contains("Gift Card")');

  isEl('.shopping-cart__list', function() {
    shoppingCartUpsell.detach().appendTo('.shopping-cart__subtotal');
  })

  if (freeProduct.length > 0 || (excludeProduct.length > 0 && shoppingCartItem.length < 2) || (excludeProduct.length === shoppingCartItem.length)) {
    shoppingCartUpsell.remove();
  
    freeProduct.closest('.shopping-cart__item').addClass('shopping-cart__item--gift');

    if (shoppingCartItem.length == 1 || (freeProduct.length > 0 && excludeProduct.length > 0 && shoppingCartItem.length == 2))
      freeProduct.closest('.shopping-cart__item').find('.remove-text').trigger('click');
  }
} else {
  let miniCartItem = $('header .header .mini-cart__item');
  let freeProduct = $('header .header .mini-cart__item-price:contains("Free")');
  let excludeProduct = $('header .header .mini-cart__item-title a:contains("Gift Card")');

  if (freeProduct.length > 0 || (excludeProduct.length > 0 && miniCartItem.length < 2) || (excludeProduct.length === miniCartItem.length)) {
    isEl('header .header .cart_content', function() {
      shoppingCartUpsell.fadeOut();
    })

    freeProduct.closest('.mini-cart__item').addClass('mini-cart__item--gift');
  }
}

// # Size guide
$('.single-card__footnote--link').click(function() {
  let sizeGuideImage;

  if ($(window).width() > 798) {
    sizeGuideImage = $(this).parent().siblings('.shopping-cart__size-guide').children('.desktop').not('.second').clone();
  } else {
    sizeGuideImage = $(this).parent().siblings('.shopping-cart__size-guide').children('.mobile').not('.second').clone();
  }

  $('.pop-up').fadeIn(500).children('.pop-up__content').append(sizeGuideImage);
});

// # Size selector
let singleCardButton = $('.single-card .global-button');

singleCardButton.attr('disabled', true).addClass('disable');

if ($(window).width() > 798) {
  $('#productSelect').on('change', function() {
    (this.value === 'selectSize') ?
      singleCardButton.attr('disabled', true).addClass('disable') :
      singleCardButton.attr('disabled', false).removeClass('disable')
  })
} else {
  setTimeout(function() {
    $('#productSelect').on('change', function() {
      (this.value === 'selectSize') ?
        $('.single-card .global-button').attr('disabled', true).addClass('disable') :
        $('.single-card .global-button').attr('disabled', false).removeClass('disable')
    })
  }, 500)
}

// # Remove the Newsletter section from the authorization page
if (window.location.href.indexOf('/account') > -1) {
  $('.newsletter-section').remove()
};

// # Forward swatch will update based on the availability of the previous option "sold-out" selected
let swatchVariants = $('.product-page__information .shopify-product-form .swatch[data-option-index="1"]:not(.color-swatch) .swatch-element');
let colorVariants = $('.product-page__information .shopify-product-form .color-swatch .swatch-element');
let upsellColorVariants = $('.pop-up--upsell .shopify-product-form .color-swatch .swatch-element');

setTimeout(function() {
  if (swatchVariants.hasClass('soldout') && swatchVariants.hasClass('available'))
    $('.product-page__information .shopify-product-form .swatch[data-option-index="1"]:not(.color-swatch) .swatch-element.soldout:not(:last-of-type)').prev('input').removeAttr('checked').siblings('.swatch-element.available:first').prev('input').attr('checked', true);
}, 250)

if (colorVariants.hasClass('soldout') && colorVariants.hasClass('available'))
  $('.product-page__information .shopify-product-form .color-swatch .input-color:first-of-type').removeAttr('checked').siblings('.swatch-element.available:first').prev('.input-color').attr('checked', true);

if (upsellColorVariants.hasClass('soldout') && upsellColorVariants.hasClass('available'))
  $('.pop-up--upsell .shopify-product-form .color-swatch .input-color:first-of-type').removeAttr('checked').siblings('.swatch-element.available:first').prev('.input-color').attr('checked', true);

// # Product swatch will update based on the availability at least one size option
productCardsSwatch();

// # Change the select dropdown width depending to children elements width
(function($, window) {
  $(function() {
    $.fn.resizeSelect = function(settings) {  
      return this.each(function() { 
        $(this).change(function() {
          let $this = $(this);

          setTimeout(function() {
            let text = $this.find('option:selected').text();

            let $test = $('<span>').html(text);

            $test.appendTo($this.parent());
              
            let width = $test.width();

            $test.remove();
            
            $this.width(width);
            console.log($test)
          }, 1)
        }).change();
      });
    };

    $('.collection-page__select select').resizeSelect();
  })
})(jQuery, window);

// # Customize YouTube play button
$(document).on('click','.js-video-poster',function(e) {
  e.preventDefault();

  var poster = $(this);
  var wrapper = poster.closest('.js-video-wrapper');

  videoPlay(wrapper);
});

function videoPlay(wrapper) {
  var iframe = wrapper.find('.js-video-iframe');
  var src = iframe.data('src');

  wrapper.addClass('video-wrapper-active');
  iframe.attr('src',src);
}

// # Search window on the desktop
if ($(window).width() > 798) {
  setTimeout(function() {
    let mobileSearch = $('.mobile-search');

    $(`${micrositeSearchIcon}, .control-container .icon-search`).on('click', function() {
      mobileSearch.addClass('mobile-search--desktop').fadeIn(200).find('input#q').attr('placeholder', 'Type to Search').focus().next().removeClass('icon-search-dark').addClass('icon-search');
      $('.close-search').remove();
    })

    $('.search-form').on('click', function(e) {
      if (e.target !== this)
        return;
    
      mobileSearch.fadeOut(200).find('[name="q"]').val('');
      $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
    })
  }, 1000)
}

// # Log-in page
let loginPageTab = $('.login-page #main-form .form__tabs div');

$('#recover-password').hide();

if (/\/account\/(login|invalid_token)/.test(window.location.href)) formLoginIn();
if (window.location.href.indexOf('/account/register') > -1) formRegisterIn();
if (window.location.href.indexOf('/account/login#recover') > -1) formRecoverIn();

loginPageTab.on('click', function() {
  loginPageTab.removeClass();

  ($(this).text().indexOf('Log in') > -1) ? formLoginIn() : formRegisterIn();
})

$('#showRecoverPasswordForm').on('click', function() {  
  formRecoverIn();
})

$('#hideRecoverPasswordForm').on('click', function() {
  $('#recover-password').hide();
  $('#main-form').fadeIn();
})

function formRegisterIn() {
  loginPageTab.first().next().addClass('form__tabs--active');

  $('.login-page .form-wrapper--login').hide();
  $('.login-page .form-wrapper--register').fadeIn();
}

function formLoginIn() {
  loginPageTab.first().addClass('form__tabs--active');

  $('.login-page .form-wrapper--register').hide();
  $('.login-page .form-wrapper--login').fadeIn();
}

function formRecoverIn() {
  $('#main-form').hide();
  $('#recover-password').fadeIn();
}

// # Delivery Address
if ($(window).width() <= 1024) {
  $('.account-page__delivery-address #add-new-address').on('click', function() {
    $(this).parent().hide();
  })

  $('.delivery-address-form__grid .buttons > *').on('click', function() {
    $(this).parents('.account-page__delivery-address').find('.center').show();
  }) 
}

isEl('.account-page__edit .cf-form-actions', function() {
  $('.cf-form-actions .cf-cancel').removeClass().addClass('global-button global-button--primary reverse').children('span').addClass('text');
  $('.cf-form-actions .cf-submit-form').removeClass().addClass('global-button global-button--primary').children('span').addClass('text');
})

// # Microsites
const micrositeSearchIcon = '.cf-microsite-nav__control-container .cf-microsite-icon-search';

// # Copper Fit X
// # Header
const $navFixed = $('.cf-microsite-nav-fixed--true');
const $micrositeSection = $('[id*=-template-x-microsite]:not(select), [id*=-template-mobilizer-microsite]:not(select), [id*=-template-microsite]:not(select)');

const promoHeight = 35;
const headerHeight = isMobile ? 48 : 78;

function handleScroll() {
  let scrollPosition = $(window).scrollTop();

  if (scrollPosition >= promoHeight) {
    $navFixed.addClass('is-enable');
    $micrositeSection.css('margin-top', `${headerHeight}px`);
  } else {
    $navFixed.removeClass('is-enable');
    $micrositeSection.removeAttr('style');
  }
}

isEl($navFixed, function() {
  $(window).scroll(handleScroll);
});

// # Utility function to update .has-sale-savings class
function updateSaleSavingsClass() {
  $('.price-ui').each(function() {
    const $info = $(this).closest('.information');
    const $qtyBox = $info.find('.product-quantity-box');

    $qtyBox.removeClass('has-sale-savings');

    // Add only if .sale.savings exists
    if ($(this).find('.sale.savings').length > 0) {
      $qtyBox.addClass('has-sale-savings');
    }
  });
}

$(document).ready(function() {
  setTimeout(updateSaleSavingsClass, 100);
});

// # Enable purchase button when a variant is selected
$('.copper-fit-x__product-page .information .swatch-options .swatch input, .copper-fit-mobilizer__product-page .information .swatch-options .swatch input').on('change', function() {
  const $container = $(this).closest('.information');
  const $purchaseDetails = $container.find('.purchase-details');

  if ($(this).is(':checked')) {
    $purchaseDetails.removeClass('disabled');
  }

  const $swatchOptionsReverse = $(this).closest('.swatch-options--reverse');
  const $currentSwatch = $(this).closest('.swatch');
  const $otherSwatch = $swatchOptionsReverse.find('.swatch').not($currentSwatch);

  if ($otherSwatch.length) {
    // Only check if none are checked in the other swatch
    if ($otherSwatch.find('input:checked').length === 0) {
      $otherSwatch.find('input').first().prop('checked', true).trigger('change');
    }
  }

  // Update .has-sale-savings class after swatch change
  setTimeout(updateSaleSavingsClass, 100);
});

// # Landings
// # Quantity limit of items on landings page
const maxAllowedProducts = 3;
const $landingPage = $('body[class*="-landing"]');
const $landingProduct = $landingPage.find('.landing__product');
const $landingContainer = $landingPage.find('.control-container');
const $landingCartButton = $landingPage.find('.cart-container a:not(.cart__remove-btn)');

$landingCartButton.removeAttr('href').attr('role', 'button');
$landingPage.find('.landing__product a').removeAttr('href').attr('role', 'button');

if (!isWideScreen) $landingCartButton.removeClass('icon-bag-dark');

$landingProduct.find('.product-card').each(function() {
  let $currentProductCard = $(this);
  let $landingProductVariantId = $(this).attr('data-variant-id');
  let sizeVariants = $currentProductCard.find('.swatch[data-option-index="1"]:not(.color-swatch) .swatch-element');

  // Check if "$landingProductVariantId" is empty and update it with the next available variant
  if (!$landingProductVariantId) {
    setTimeout(function() {
      const $soldOutVariants = sizeVariants.filter('.soldout:not(:last-of-type)');
      const $availableVariant = $soldOutVariants.siblings('.swatch-element.available:first').attr('data-id');

      if ($availableVariant)
        $currentProductCard.attr('data-variant-id', $landingProductVariantId);
    }, 250);
  }

  // Update product card shadowing on page load
  $landingContainer.find('.mini-cart__item').each(function() {
    const $variantId = $(this).attr('data-variant-id');
    const $quantity = $(this).find('.quantity').val();

    $landingProduct.find('.product-card').each(function() {
      if ($quantity == maxAllowedProducts)
        $landingProduct.find('.product-card[data-variant-id="' + $variantId + '"]').addClass('disabled');
    })
  });
})

// Unshadowing product card on page load
$landingContainer.find('.cart__remove-btn').on('click', function() {
  const $variantId = $(this).parents('.mini-cart__item').attr('data-variant-id');

  $landingProduct.find('.product-card[data-variant-id="' + $variantId + '"]').removeClass('disabled');
})

// Toggle product card shadowing depending on the item quantity
$landingContainer.on('click', '.js-change-quantity', function() {
  const $clickedElement = $(this);
  const $variantId = $clickedElement.parents('.mini-cart__item').attr('data-variant-id');

  setTimeout(function() {
    const $productCard = $landingProduct.find('.product-card[data-variant-id="' + $variantId + '"]');
    const $isMaxQuantityReached = $clickedElement.parent().find('.quantity').val() == maxAllowedProducts;

    $productCard.toggleClass('disabled', $isMaxQuantityReached);
  }, 100);
});

// Fill in the "data-variant-id" attribute on a swatch click
$landingProduct.find('.swatch-options input').on('click', function() {
  const $productCard = $(this).parents('.product-card');
  const $variantId = $(this).next().attr('data-id');

  $productCard.attr('data-variant-id', $variantId);

  // Get the selected product type and size
  const $productType = $(this).closest('.swatch-options').find('input[name="option-0"]:checked').next().find('label').text().trim();
  const $productSize = $(this).closest('.swatch-options').find('input[name="option-1"]:checked').next().find('label').text().trim();

  let $combinedProduct = $productType + ' / ' + $productSize;

  // Check for the selected product color, if available
  const $productColor = $productCard.find('.color-variant-options input').val();

  if ($productColor) $combinedProduct += ' / ' + $productColor;

  // Find the option element that matches the combined product type and size
  const $sizesOptions = $('optgroup[label="Sizes"] option');
  const $matchedOption = $sizesOptions.filter((_index, element) => $(element).text().trim() === $combinedProduct);

  // Get the value attribute from matched option and set data-variant-id
  const $matchedVariantId = $matchedOption.attr('value');

  console.log($matchedVariantId);

  if ($matchedVariantId) $productCard.attr('data-variant-id', $matchedVariantId);
})

// Function to handle disabling plus button based on quantity
function handlePlusButton($container, maxAllowedProducts) {
  $container.find('.quantity').each(function() {
    const $item = $(this).closest('.product-card, .mini-cart__item');
    const $quantity = parseInt($(this).val(), 10);

    disablePlusButton($item);

    if ($quantity < maxAllowedProducts) {
      setTimeout(() => {
        enablePlusButton($item);
      }, 500);
    }
  });
}

function disablePlusButton($element) {
  $element.find('.product-plus').addClass('disabled');
}

function enablePlusButton($element) {
  $element.find('.product-plus').removeClass('disabled');
}

// Event handler for product card quantity change
$landingProduct.on('change', '.quantity', function() {
  const $productCard = $(this).closest('.product-card');

  handlePlusButton($productCard, maxAllowedProducts);
});

// Event handler for mini cart quantity change
$landingContainer.on('change', '.quantity', function() {
  const $miniCartItem = $(this).closest('.mini-cart__item');

  disablePlusButton($miniCartItem);
});

// Disable plus button in mini cart on page load
$landingContainer.find('.mini-cart__item .quantity').each(function() {
  const $item = $(this).closest('.mini-cart__item');
  const $quantity = parseInt($(this).val(), 10);

  if ($quantity === maxAllowedProducts) {
    disablePlusButton($item);
  }
});

const targetButtonClass = isWideScreen ? '.global-button' : '.choose-variant-button';

$landingProduct.on('click', targetButtonClass, function(event) {
  const $productCard = $(this).parents('.product-card');
  const $currentProductId = $productCard.attr('data-variant-id');
  const $cartItems = $landingPage.find('.control-container .mini-cart__item');
  const $quantity = parseInt($productCard.find('.quantity').val());
  
  let $quantityOfCurrentProductInCart = 0;

  $cartItems.each(function() {
    const $productIdInCart = $(this).attr('data-variant-id');

    if ($productIdInCart === $currentProductId)
      $quantityOfCurrentProductInCart += parseInt($(this).find('.quantity').val());
  });

  if ($quantityOfCurrentProductInCart + $quantity > maxAllowedProducts) {
    event.preventDefault();

    const errorMessage = '<p class="landing__error-message">You can add a maximum of 3 items of each product variant to the cart</p>'
    const $errorElement = $(errorMessage).hide();
  
    $errorElement.appendTo('.landing__product .section').fadeIn('slow');

    setTimeout(() => {
      $errorElement.fadeOut('slow', function() {
        $(this).remove();
      });
    }, 3500);
    
    return false;
  }

  if ($quantityOfCurrentProductInCart + $quantity === maxAllowedProducts) {
    $productCard.addClass('disabled');
  }

  if ($quantity >= maxAllowedProducts) {
    $productCard.addClass('disabled');
  }
})

// # Pixels
const validPaths = [
  '/pages/arch-strong',
  '/pages/arch-relief',
  '/pages/core-shaper',
  '/pages/energy-compression-socks'
];

if (validPaths.includes(window.location.pathname)) {
  sessionStorage.setItem('checkout_referrer', window.location.pathname);
}

// # Strengthen the users password
document.addEventListener('DOMContentLoaded', function() {
  var passwordInputs = document.querySelectorAll('input[type="password"].strengthen-password');

  passwordInputs.forEach(function(passwordInput) {
    passwordInput.addEventListener('input', function() {
      var password = passwordInput.value;
      var passwordStrengthRegex = /^(?=.*\d)(?=.*\W)(?=.*[a-z])(?=.*[A-Z]).{12,20}$/;

      if (!passwordStrengthRegex.test(password)) {
        passwordInput.setCustomValidity('The password must contain at least one digit, a symbol, and a capital letter and be between 12 and 20 characters long.');
      } else {
        passwordInput.setCustomValidity('');
      }
    });
  });
});

// # Hide the BIS button on Medical Grade Compression Socks (temporary solution)
if (window.location.href.indexOf('/products/medical-grade-compression-socks') > -1) {
  isEl('.bis-reset', function() {
    $('.bis-reset').hide();
  })
}
